import { render, staticRenderFns } from "./SmsTmplList.vue?vue&type=template&id=d5d5f6e0&"
import script from "./SmsTmplList.vue?vue&type=script&lang=js&"
export * from "./SmsTmplList.vue?vue&type=script&lang=js&"
import style0 from "./SmsTmplList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports